module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 9.807125aa.png";